import router from '../router/index.js'
export function qxLink(name,params={}){
		console.log(name,params);
		router.push({
			name,
			params,
		})
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/common.ts
// module id = null
// module chunks = 